// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
const typedjson_1 = require("../export/typedjson");
const assets_1 = require("./assets");
/**
 * Account is the state of a user within Erdstall, including the last nonce and
 * free locked assets. It is returned by an `EnclaveReader.getAccount` query.
 */
let Account = class Account {
    constructor(nonce, values, locked) {
        this.nonce = nonce;
        this.values = values;
        if (locked === undefined) {
            locked = new assets_1.Assets();
        }
        this.locked = locked;
    }
};
__decorate([
    typedjson_1.jsonBigIntMember(),
    __metadata("design:type", typeof BigInt === "function" ? BigInt : Object)
], Account.prototype, "nonce", void 0);
__decorate([
    typedjson_1.jsonMember(() => assets_1.Assets),
    __metadata("design:type", assets_1.Assets)
], Account.prototype, "values", void 0);
__decorate([
    typedjson_1.jsonMember(() => assets_1.Assets),
    __metadata("design:type", assets_1.Assets)
], Account.prototype, "locked", void 0);
Account = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [typeof BigInt === "function" ? BigInt : Object, assets_1.Assets, assets_1.Assets])
], Account);
exports.Account = Account;
//# sourceMappingURL=account.js.map